import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WebhookRoutingModule } from './webhook-routing.module';
import { WebhooksComponent } from './pages/webhooks/webhooks.component';
import { RegisterWebhookComponent } from './components/register-webhook/register-webhook.component';

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
@NgModule({
  declarations: [
    WebhooksComponent,
    RegisterWebhookComponent,
  ],
  imports: [
    CommonModule,
    WebhookRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class WebhookModule { }
